import type { LegacyRef, ReactNode } from "react"
import { forwardRef } from "react"

export type SectionProps = JSX.IntrinsicAttributes & {
  children?: ReactNode
  className?: string
  flexHeight?: boolean // remove min-height-screen
  bgClass?: string
  id?: string
}

const Section = ({ children, className, flexHeight, bgClass, ...props }: SectionProps, ref: LegacyRef<HTMLElement> | undefined) => {
  return (
    <section
      id={props.id ?? ""}
      ref={ref}
      className={`relative overflow-hidden ${bgClass ?? ""} ${flexHeight ? "" : "min-h-[min(50vh,400px)] md:min-h-[32rem] lg:min-h-lg xl:min-h-xl 2xl:min-h-[44rem] max:min-h-[50em]"} ${className ?? ""}`}
    >
      {children}
    </section>
  )
}

export default forwardRef(Section)
